import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

export default function ChartOverlay({ open, title, onClose, drawer = false, children }: {
    open: boolean; title: string; onClose: () => void; drawer?: boolean; children: React.ReactNode;
}) {
    const dialog = useRef<HTMLDialogElement>(null);
    useEffect(() => {
        const element = dialog.current!;
        if (open && !element.open) element.showModal();
        if (!open && element.open) element.close();
    }, [open]);

    return createPortal(<dialog ref={dialog} aria-label={title}
        onCancel={event => { event.preventDefault(); onClose(); }}
        onClick={event => {
            if (event.target !== event.currentTarget) return;
            const bounds = event.currentTarget.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right
                || event.clientY < bounds.top || event.clientY > bounds.bottom) onClose();
        }}
        className={`p-0 max-w-none max-h-none bg-white text-gray-800 shadow-xl backdrop:bg-black/40 ${drawer
            ? 'fixed inset-x-0 bottom-0 top-auto m-0 w-full h-[85dvh] rounded-t-2xl md:left-auto md:top-0 md:w-[400px] md:h-[100dvh] md:rounded-none'
            : 'rounded-xl w-[min(380px,94vw)]'}`}>
        <div className={`flex flex-col ${drawer ? 'h-full' : 'max-h-[85dvh]'}`}>
            <header className="flex items-center justify-between gap-3 p-3 border-b shrink-0">
                <h2 className="font-bold">{title}</h2>
                <button type="button" aria-label={`Close ${title.toLowerCase()}`} onClick={onClose}
                    className="rounded border px-3 py-2 text-sm hover:bg-gray-100">Close</button>
            </header>
            <div className="min-h-0 overflow-y-auto overscroll-contain">{children}</div>
        </div>
    </dialog>, document.body);
}
